var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEtHprice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon - ETH"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 6",
    d: "M4.94238 12.9886L11.8142 22.5103V17.0308L4.94238 12.9886Z",
    fill: "#F8FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 5",
    d: "M11.8142 22.6002L18.5962 12.9886L11.8142 17.0758V22.6002Z",
    fill: "#A5D7FD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 4",
    d: "M11.7693 10.15V15.6116L15.8654 12.5155L11.7693 10.15Z",
    fill: "#4EB2FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3",
    d: "M11.7693 0.592346V8.67686L4.94238 11.8208L11.7693 0.592346Z",
    fill: "#F8FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M18.5962 11.731L11.7693 8.6768V0.592285L18.5962 11.731Z",
    fill: "#A5D7FD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M7.6731 12.5851L11.7692 15.6116L11.7425 10.15L7.6731 12.5851Z",
    fill: "#9DD4FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtHprice);
export default __webpack_public_path__ + "static/media/ETHprice.266079df62c4a9bc69918d11d466fc06.svg";
export { ForwardRef as ReactComponent };